import cx from 'classnames';
import { toLower } from 'lodash';
import React, { useMemo } from 'react';

import { FLAG_ICON_COUNTRY_CODES } from 'constants/flags.constants';
import { IMAGES_PATH } from 'constants/images.constants';

type Props = {
  countryCode: string;
  className?: string;
};

// AB is not part of ISO 3166-1, so flag-icons has no Abkhazian flag even though the
// backend does emit that code (transform-order.utils.ts). The asset is kept locally and,
// like every flag-icons asset, normalized to 4:3 so it fits the same box.
const CUSTOM_FLAG_PATHS: Record<string, string> = {
  ab: `${IMAGES_PATH}flags/ab.svg`,
};

export const SqCountryFlag: React.FC<Props> = ({ countryCode, className }) => {
  const code = useMemo(() => toLower(countryCode), [countryCode]);

  const customFlagPath = useMemo(() => CUSTOM_FLAG_PATHS[code], [code]);

  if (customFlagPath) {
    return (
      <img src={customFlagPath} alt="" aria-hidden className={className} />
    );
  }

  // Providers send the country in various formats, so a currency code (UZS) can reach
  // countryCode when normalization misses: there is no fi-uzs class and the base .fi
  // would render an empty box in place of the flag.
  if (!FLAG_ICON_COUNTRY_CODES.has(code)) {
    return null;
  }

  // flag-icons CSS loads after tailwind, so its .fi width needs the important modifier to
  // be overridden. aria-hidden is for .fi:before, whose nbsp would otherwise be announced
  // by screen readers ahead of the country name.
  return <span aria-hidden className={cx(`fi fi-${code}`, className)} />;
};
